import script from "./gbzntyj.vue?vue&type=script&setup=true&lang=js"
export * from "./gbzntyj.vue?vue&type=script&setup=true&lang=js"

import "./gbzntyj.vue?vue&type=style&index=0&id=0ef3c53a&lang=less&scoped=true"
script.__scopeId = "data-v-0ef3c53a"

export default script